import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export const FavoritedStar = ({
  height = 24,
  width = 24,
  fillColor,
  isFilled = false,
  ...rest
}: FavoritedStarProps & SvgProps) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.icons.starRatingIcon.fill

  return isFilled ? (
    <Svg width={width} height={height} viewBox='0 0 24 24' fill='none' testID={tID('FavoritedStar')} {...rest}>
      <Path
        d='M12.0001 18.0198L16.1501 20.5298C16.9101 20.9898 17.8401 20.3098 17.6401 19.4498L16.5401 14.7298L20.2101 11.5498C20.8801 10.9698 20.5201 9.86977 19.6401 9.79977L14.8101 9.38977L12.9201 4.92977C12.5801 4.11977 11.4201 4.11977 11.0801 4.92977L9.19007 9.37977L4.36007 9.78977C3.48007 9.85977 3.12007 10.9598 3.79007 11.5398L7.46007 14.7198L6.36007 19.4398C6.16007 20.2998 7.09007 20.9798 7.85007 20.5198L12.0001 18.0198Z'
        fill={fill}
      />
    </Svg>
  ) : (
    <Svg width={width} height={height} viewBox='0 0 24 24' fill='none' testID={tID('FavoritedStar')} {...rest}>
      <Path
        d='M12 3.667l2.575 5.217 5.758.841-4.166 4.059.983 5.733L12 16.809l-5.15 2.708.983-5.733-4.166-4.059 5.758-.841L12 3.667z'
        stroke={fill}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  )
}

export type FavoritedStarProps = {
  height?: number
  width?: number
  fillColor?: string
  isFilled?: boolean
}
